import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20golden%20and%20beige%20abstract%20flowing%20texture%20with%20elegant%20gradients%2C%20soft%20diffused%20warm%20light%2C%20luxurious%20paper%20texture%20background%2C%20sophisticated%20and%20minimal%20composition%2C%20creamy%20warm%20tones%20with%20amber%20highlights%2C%20professional%20and%20authoritative%20feel&width=1600&height=700&seq=cta-bg-huangbenzi&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          还有疑问？联系我们
        </h2>
        <p className="text-sm md:text-base text-background-200 max-w-xl mx-auto mb-8 leading-relaxed">
          我们的团队随时准备为您解答关于黄本子的任何疑问，提供专业、及时的指导服务
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/changjian-wenti"
            className="w-full sm:w-auto px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium text-sm rounded-lg backdrop-blur-sm border border-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看FAQ
            <i className="ri-question-answer-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}